const FORBIDDEN_RE = new RegExp(
  "[" +
    "\\u0000-\\u001F" + // C0 controls
    "\\u007F" +         // DEL
    "\\u0085" +         // NEL
    "\\u2028\\u2029" +  // line/paragraph separator
    "\\u202A-\\u202E" + // bidi formatting
    "\\u2066-\\u2069" + // bidi isolates
    "\\u200B-\\u200F" + // zero-width / format
    "\\u2060" +         // word joiner
    "\\uFEFF" +         // BOM
  "]",
);

const EMOJI_RE = /\p{Extended_Pictographic}/u;

const PUA_RE = new RegExp(
  "[" +
    "\\uE000-\\uF8FF" +     // BMP Private Use Area
    "\\u{F0000}-\\u{FFFFD}" + // Supplementary PUA-A
    "\\u{100000}-\\u{10FFFD}" + // Supplementary PUA-B
  "]",
  "u",
);

const TRIM_RE = new RegExp(
  "^[" +
    "\\t\\n\\v\\f\\r " +
    "\\u00A0\\u1680\\u2000-\\u200A\\u202F\\u205F\\u3000" +
  "]+" +
  "|[" +
    "\\t\\n\\v\\f\\r " +
    "\\u00A0\\u1680\\u2000-\\u200A\\u202F\\u205F\\u3000" +
  "]+$",
  "g",
);

export type NameValidationResult =
  | { ok: true; value: string }
  | { ok: false; error: string };

export function validateSafeName(
  raw: string,
  maxLength: number,
  field: string,
): NameValidationResult {
  const normalized = raw.normalize("NFC");
  const trimmed = normalized.replace(TRIM_RE, "");

  if (trimmed.length === 0) {
    return { ok: false, error: `${field} cannot be empty` };
  }

  if (trimmed.length > maxLength) {
    return {
      ok: false,
      error: `${field} exceeds maximum length of ${maxLength} characters`,
    };
  }

  if (FORBIDDEN_RE.test(trimmed)) {
    return { ok: false, error: `${field} contains forbidden characters` };
  }

  if (EMOJI_RE.test(trimmed)) {
    return { ok: false, error: `${field} cannot contain emoji` };
  }

  if (PUA_RE.test(trimmed)) {
    return { ok: false, error: `${field} contains forbidden characters` };
  }

  return { ok: true, value: trimmed };
}

export function isNameValid(raw: string, maxLength: number): boolean {
  return validateSafeName(raw, maxLength, "").ok;
}
